import React, { useEffect, useState } from 'react';
import API from '../ReportsAPI';
import moment from 'moment';
import { CDN_ROOT, PAGE } from '../ReportsConfig';
import { Link, useNavigate } from 'react-router-dom';
import { Header, Button } from 'react-frontier';
import { LoginTokenType } from '@arema/components/Classes';

var LoginResponse = ()=>{
	var [loginError, setLoginError] = useState<string>(null);
	var query = new URLSearchParams(window.location.search);
	var navigate = useNavigate();

	useEffect(()=>{
		var token = query.get('at');
		var redirect = query.get('r');
		var expiration = parseInt(query.get('e'));
		var login_type = parseInt(query.get('lt'));

		var now = moment().unix()
		if(!expiration || Number.isNaN(expiration) || expiration<(now+30)) return setLoginError('La autenticación de usuario ha expirado');
		if (isNaN(login_type) || [LoginTokenType.ADMIN, LoginTokenType.EXTERNAL].indexOf(login_type)==-1) return setLoginError('Tipo de login incorrecto');
		if(!redirect || redirect.length<9) redirect = PAGE;
		var is_local_route = false;
		if(redirect.startsWith(window.location.origin)){
			is_local_route = true;
			redirect = redirect.substring(window.location.origin.length);
		}
		API.onLoginToken(login_type, token, expiration, is_local_route).then(res=>{
			if(res.error) return setLoginError(res.message);
			if(is_local_route && navigate){
				navigate(redirect);
			}else{
				window.location.href = redirect;
			}
		}).catch(err=>{
			return setLoginError('Hubo un error inesperado haciendo login. (LCL-AUTHRP-1)');
		});
	}, []);

	if(loginError){
		return <div style={{ marginTop: 20 }}>
			<Header text='Error' size='big' centered subtext={`Hubo un error inesperado haciendo login: ${loginError}`} style={{ maxWidth: 500, margin: 'auto' }} />
			<Button basic as={Link} color='black' text={'Cerrar sesión'} to={API.getAuthUrl(query.get('r') || '/')} style={{ display: 'block', margin: 'auto', width: 200, marginTop: 15 }} />
		</div>
	}
	
	return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
		<img src={`${CDN_ROOT}/assets/logo/LogoG_Small.png`} alt="AREMA" style={{ borderRadius: 4 }} />
	</div>
}

export default LoginResponse;